module.exports = __webpack_public_path__ + "static/media/battlefield2.c17d6a19.jpg";